<template>
  <CenteredContainer class="vertical-spacing">
    <SfHeading class="sf-heading--left" :level="1" :title="$t('Logging out!')" />
  </CenteredContainer>
</template>
<script>
import { SfHeading } from '@storefront-ui/vue';
import CenteredContainer from '../components/CenteredContainer.vue';
import user from '../mixins/user';

export default {
  name: 'LogOut',
  mixins: [user],
  components: {
    CenteredContainer,
    SfHeading,
  },
  created() {
    this.logout().finally(() => {
      this.$router.push('/');
    });
  },
};
</script>
<style lang="less" scoped></style>
